/* eslint-disable react/prop-types */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // If path is /admin and user is not an admin, redirect to dashboard
  if (location.pathname === '/admin' && !user.isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  // Otherwise, render the children
  return <>{children}</>;
};

export default PrivateRoute;
